import { inject, Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { filter } from 'rxjs';

import { ConfirmationDialogService } from '@shared/features/dialog/features/confirmation-dialog/data-access/confirmation-dialog.service';
import { ConfirmationDialogComponent } from '@shared/features/dialog/features/confirmation-dialog/features/dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorDialogService {
  private readonly confirmationDialogService = inject(ConfirmationDialogService);
  private dialogRef: MatDialogRef<ConfirmationDialogComponent> | null = null;

  openRefreshDialog(): void {
    if (this.dialogRef) {
      return;
    }

    this.dialogRef = this.confirmationDialogService.open({
      title: 'Nowa wersja aplikacji',
      subTitle: '',
      message: 'Dostępna jest nowa wersja aplikacji. Odśwież stronę, aby zaktualizować.',
      icon: {
        show: true,
        name: 'tabler-refresh',
        color: 'primary',
      },
      actions: {
        confirm: {
          show: true,
          label: 'Odśwież teraz',
          color: 'primary',
        },
        cancel: {
          show: true,
          label: 'Później',
        },
      },
      dismissible: true,
    });

    this.dialogRef
      .afterClosed()
      .pipe(filter((result) => result?.success))
      .subscribe(() => {
        window.location.reload();
      });

    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }
}
